import { VFC, useMemo } from 'react';
import { AutoComplete as AntdAutoComplete, AutoCompleteProps as AntdAutoCompleteProps } from 'antd';
import { removeAccents } from 'utils/removeAccents';
import { DefaultOptionType } from 'antd/lib/select';
import { filterSort } from './utils/filterSort';

interface AutoCompleteProps extends AntdAutoCompleteProps<string, DefaultOptionType> {
  suggestions: string[];
}

export const AutoComplete: VFC<AutoCompleteProps> = ({ suggestions, ...rest }) => {
  const options = useMemo(
    () =>
      suggestions.map<DefaultOptionType>(suggestion => ({
        value: suggestion,
        label: suggestion,
      })),
    [suggestions],
  );

  const filterOption = (inputValue: string, option?: DefaultOptionType): boolean => {
    const normalizedInput = removeAccents(inputValue.toLocaleLowerCase());
    const normalizedOptionValue = removeAccents(option?.value?.toString().toLocaleLowerCase() ?? '');

    return normalizedOptionValue.includes(normalizedInput);
  };

  return <AntdAutoComplete filterOption={filterOption} filterSort={filterSort} options={options} {...rest} />;
};
